import React, { useState } from "react";
import TableComponent from "../../../components/TableComponent/TableComponentFiltro";

export const Prestamos = () => {
  const cabeceras = [
    "Id", //0
    "Nombre", //1
    "Editar",
    "Eliminar",
  ];
  const [parametros] = useState({
    action: "datatable",
    table: "types_loan",
    rows: "keyTypeLoan,nameTypeLoan", ///sin espacios y comas
    conditions: "enabled = 1",
    page: 0,
    records: 5,
    search: "",
    order: "",
  });

  return (
    <div>
      <TableComponent
        titulo="Tipos de Prestamos"
        cabecerasTabla={cabeceras}
        filtro={null}
        rutaCrear="/template/prestamos-nomina/crear"
        rutaEditar="/template/prestamos-nomina/editar"
        parametros={parametros}
      ></TableComponent>
    </div>
  );
};
export default Prestamos;
